// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"5b9ec339","136":"9c90985c","256":"32a9b7f5","395":"02a14d42","418":"9ebc126f","453":"10e18f63","713":"28cf3dee","807":"d7e43932","972":"d32717da"}[chunkId] + ".chunk.js";
};